import {
  CHANGE_DIRECTION,
  CHANGE_NAVIGATION_STYLE,
  DARK_THEME,
  DRAWER_TYPE,
  COLLAPSED_DRAWER,
  HORIZONTAL_MENU_POSITION,
  INSIDE_THE_HEADER,
  SET_YEAR_FILTER,
  SET_LANGUAGE,
  SET_CURRENCY,
  SWITCH_LANGUAGE,
  SWITCH_CURRENCY,
  THEME_COLOR,
  TOGGLE_COLLAPSED_NAV,
  VERTICAL_NAVIGATION,
  WINDOW_WIDTH
} from '../constants/ActionTypes';
import { DEEP_ORANGE } from '../constants/ThemeColors';

// const rltLocale = ['ar'];
const initialState = {
  navCollapsed: false,
  drawerType: COLLAPSED_DRAWER,
  themeColor: DEEP_ORANGE,
  darkTheme: false,
  width: window.innerWidth,
  isDirectionRTL: false,
  navigationStyle: VERTICAL_NAVIGATION,
  horizontalNavPosition: INSIDE_THE_HEADER,
  locale: {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us'
  },
  yearFilter: localStorage.getItem('yearList')
    ? JSON.parse(localStorage.getItem('yearList'))
    : [{value: new Date().getFullYear(), label: new Date().getFullYear()}],
  language: localStorage.getItem('languageList')
    ? JSON.parse(localStorage.getItem('languageList'))
    : [],
  languageSelected: localStorage.getItem('languageSelected')
    ? JSON.parse(localStorage.getItem('languageSelected'))
    : {
        id: 1,
        code: "th-TH",
        name: "Thai (Thailand)",
        icon: "th_th.png"
      },
  currency: localStorage.getItem('currencyList')
    ? JSON.parse(localStorage.getItem('currencyList'))
    : [],
  currencySelected: localStorage.getItem('currencySelected')
    ? JSON.parse(localStorage.getItem('currencySelected'))
    : {
        code: "THB",
        rate: 1,
      },
};

const settings = (state = initialState, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return {
        ...state,
        navCollapsed: false
      };
    case TOGGLE_COLLAPSED_NAV:
      return {
        ...state,
        navCollapsed: action.isNavCollapsed
      };
    case DRAWER_TYPE:
      return {
        ...state,
        drawerType: action.drawerType
      };
    case WINDOW_WIDTH:
      return {
        ...state,
        width: action.width
      };
    case THEME_COLOR:
      return {
        ...state,
        darkTheme: false,
        themeColor: action.color
      };
    case DARK_THEME:
      return {
        ...state,
        darkTheme: !state.darkTheme
      };

    case SET_YEAR_FILTER:
      return {
        ...state,
        yearFilter: action.payload
      };

    case SET_LANGUAGE:
      return {
        ...state,
        language: action.payload
      };

    case SET_CURRENCY:
      return {
        ...state,
        currency: action.payload
      }

    case SWITCH_LANGUAGE:
      return {
        ...state,
        languageSelected: action.payload,
        //isDirectionRTL: rltLocale.includes(action.payload.locale)
      };

    case SWITCH_CURRENCY:
      return {
        ...state,
        currencySelected: action.payload
      };

    case CHANGE_DIRECTION:
      return {
        ...state,
        isDirectionRTL: !state.isDirectionRTL

      };

    case CHANGE_NAVIGATION_STYLE:
      return {
        ...state,
        navigationStyle: action.payload
      };

    case HORIZONTAL_MENU_POSITION:
      return {
        ...state,
        horizontalNavPosition: action.payload
      };

    default:
      return state;
  }
};

export default settings;
